import React from 'react';

const CalcSummary = ({ waterAvailable, waterNeeded, valid }) => {
  
  if(!valid){
    return null;
  }

  if(waterNeeded === 0){
    return <div className="mt"><p>Je nastaven nulový počet obyvatel a nulová plocha zahrady</p></div>
  }

  const result = Math.min(waterAvailable, waterNeeded).toFixed(1);

  return (
    <div className="mt"><p>Podle zadaných parametrů doporučujeme nádrž o objemu {result} m<sup>3</sup> nebo větší s ohledem na aktuální klimatický trend ve vaší lokalitě.</p></div>
  )
}

export default CalcSummary;